import React from "react";
import { useNavigate } from "react-router-dom";
import SidebarItems from "./SidebarItems";
import { SidebarRoute } from "../../utils/routes/types";

interface IProps {
  routes?: SidebarRoute[] | undefined;
}
const Sidebar = ({ routes }: IProps) => {
  const navigate = useNavigate();
  return (
    <aside className="app-sidebar sticky" id="sidebar">
      {/* Start::main-sidebar-header */}
      <div className="main-sidebar-header">
        <div
          onClick={() => navigate("/dashboard")}
          className="header-logo cursor-pointer"
        >
          <img
            src="/assets/images/brand-logos/desktop-logo.png"
            alt="logo"
            className="desktop-logo"
          />
          <img
            src="/assets/images/brand-logos/toggle-dark.svg"
            alt="logo"
            className="toggle-dark"
          />
          <img
            src="/assets/images/brand-logos/desktop-dark.png"
            alt="logo"
            className="desktop-dark"
          />
          <img
            src="/assets/images/brand-logos/toggle-logo.svg"
            alt="logo"
            className="toggle-logo"
          />
        </div>
      </div>
      {/* End::main-sidebar-header */}
      {/* Start::main-sidebar */}
      <div className="main-sidebar" id="sidebar-scroll" data-simplebar="init">
        <div className="simplebar-wrapper" style={{ margin: "-8px 0px -80px" }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer" />
          </div>
          <div className="simplebar-mask">
            <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
              <div
                className="simplebar-content-wrapper"
                tabIndex={0}
                role="region"
                aria-label="scrollable content"
                style={{ height: "100%", overflow: "hidden" }}
              >
                <div
                  className="simplebar-content"
                  style={{ padding: "8px 0px 80px" }}
                >
                  {/* Start::nav */}
                  <nav className="main-menu-container nav nav-pills flex-column sub-open active">
                    <div className="slide-left active d-none" id="slide-left">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#7b8191"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
                      </svg>
                    </div>
                    <SidebarItems routes={routes} />
                    <div className="slide-right d-none" id="slide-right">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#7b8191"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
                      </svg>
                    </div>
                  </nav>
                  {/* End::nav */}
                </div>
              </div>
            </div>
          </div>
          <div
            className="simplebar-placeholder"
            style={{ width: 239, height: 148 }}
          />
        </div>
        <div
          className="simplebar-track simplebar-horizontal"
          style={{ visibility: "hidden" }}
        >
          <div
            className="simplebar-scrollbar"
            style={{ width: 0, display: "none" }}
          />
        </div>
        <div
          className="simplebar-track simplebar-vertical"
          style={{ visibility: "hidden" }}
        >
          <div
            className="simplebar-scrollbar"
            style={{ height: 0, display: "none" }}
          />
        </div>
      </div>
      {/* End::main-sidebar */}
    </aside>
  );
};

export default Sidebar;
